import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Route3 = ({
  width = 430,
  height = 428,
  stroke = colors.light,
  opacity = 1,
  offset = 0,
  pathLength = 1298,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 430 428"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        strokeWidth="3"
        stroke={stroke}
        opacity={opacity}
        ref={forwardRef}
        strokeDashoffset={offset * pathLength}
        strokeDasharray={pathLength}
        d="M387.112,104.07C395.5,99 399.112,92.0703 402.112,93.5703C404.392,94.7105 403.112,97.0703 403.112,101.07C403.112,105.07 411.153,108.07 416.483,108.07C422,108.07 424.277,107.817 427.612,117.57C432.741,132.57 421.112,182.57 416.483,243.07C414.415,270.093 393.87,280.973 373,294C353.888,305.93 391.5,317 409,334.5C424.57,350.07 409,359.5 393,356.5C379.228,353.918 380.612,387.07 343.112,408.07C288.806,438.482 255.007,418.834 228.112,424.57C205,429.5 184.112,423.641 184.112,408.07C184.112,392.5 176.771,386.035 174,375.5C171.933,367.642 175.181,360.925 171,357.5C121.5,316.952 169.077,294.389 162.483,274C156.5,255.5 109.112,207.57 95.6124,213.07C82.1124,218.57 82.2123,213.87 76.6124,213.07C69.6124,212.07 69.6119,226.07 58.1124,226.07C20.6121,226.07 3.11188,188.57 3.11156,155.07C3.11123,121.57 -1.63927,110.07 3.11154,97.5703C12.6131,72.5706 51.8941,46.4941 69.1119,43.5703C97.1119,38.8156 141.112,32.0703 151.612,32.0703C162.112,32.0703 158.112,13.0703 155.612,13.0703C153.112,13.0703 149.112,16.0703 143.612,16.0703C138.112,16.0703 151.112,2.07056 148.612,1.07032C146.112,0.0700931 138.112,10.0703 127.112,10.07"
      />
    </svg>
  )
}

export default Route3
